export const practitionerTitleoptions = [
  { value: "Integration Coach", label: "Integration Coach" },
  { value: "Psychedelic Therapist", label: "Psychedelic Therapist" },
  { value: "Somatic Therapist", label: "Somatic Therapist" },
  { value: "Trauma-Informed Coach", label: "Trauma-Informed Coach" },
  { value: "Addiction Counselor", label: "Addiction Counselor" },
  {
    value: "Mindfulness and Meditation Instructor",
    label: "Mindfulness and Meditation Instructor",
  },
  { value: "Entheogenic Educator", label: "Entheogenic Educator" },
  { value: "Spiritual Guide", label: "Spiritual Guide" },
  { value: "Psychospiritual Companion", label: "Psychospiritual Companion" },
  {
    value: "Preparation and Aftercare Guide",
    label: "Preparation and Aftercare Guide",
  },
  { value: "Shamanic Practitioner", label: "Shamanic Practitioner" },
  { value: "Ceremonial Facilitator", label: "Ceremonial Facilitator" },
  { value: "Plant Spirit Healer", label: "Plant Spirit Healer" },
  { value: "Sacred Space Holder", label: "Sacred Space Holder" },
  { value: "Lineage-Based Guide", label: "Lineage-Based Guide" },
  { value: "Curandero / Curandera", label: "Curandero / Curandera" },
  { value: "Visionary Artist", label: "Visionary Artist" },
  { value: "Sound Guide", label: "Sound Guide" },
  { value: "Medical Doctor (MD)", label: "Medical Doctor (MD)" },
  { value: "Psychiatrist", label: "Psychiatrist" },
  { value: "Clinical Psychologist", label: "Clinical Psychologist" },
  { value: "Registered Nurse (RN)", label: "Registered Nurse (RN)" },
  {
    value: "Licensed Clinical Social Worker (LCSW)",
    label: "Licensed Clinical Social Worker (LCSW)",
  },
  {
    value: "Ketamine-Assisted Therapist",
    label: "Ketamine-Assisted Therapist",
  },
  { value: "Clinical Researcher", label: "Clinical Researcher" },
  { value: "Scientist", label: "Scientist" },
  { value: "Trip Sitter", label: "Trip Sitter" },
  { value: "Peer Support Sitter", label: "Peer Support Sitter" },
  { value: "Harm Reduction Specialist", label: "Harm Reduction Specialist" },
  {
    value: "Community Circle Facilitator",
    label: "Community Circle Facilitator",
  },
  { value: "Psychedelic Chaplain", label: "Psychedelic Chaplain" },
  { value: "Group Journey Facilitator", label: "Group Journey Facilitator" },
];

export const toneOptions = [
  { value: "Warm & Supportive", label: "Warm & Supportive" },
  { value: "Clinical & Precise", label: "Clinical & Precise" },
  { value: "Spiritual & Reflective", label: "Spiritual & Reflective" },
  { value: "Friendly & Conversational", label: "Friendly & Conversational" },
  { value: "Neutral & Balanced", label: "Neutral & Balanced" },
  { value: "Direct & Action-Oriented", label: "Direct & Action-Oriented" },
  { value: "Gentle & Trauma-Informed", label: "Gentle & Trauma-Informed" },
  { value: "Psychedelic-Futurist", label: "Psychedelic-Futurist" },
];

export const focusAreaOptions = [
  { value: "Preparation Support", label: "Preparation Support" },
  { value: "Integration Support", label: "Integration Support" },
  { value: "Microdosing Guidance", label: "Microdosing Guidance" },
  { value: "Trauma-Informed Holding", label: "Trauma-Informed Holding" },
  { value: "Harm Reduction", label: "Harm Reduction" },
  {
    value: "Sacred Ceremony Integration",
    label: "Sacred Ceremony Integration",
  },
  { value: "Crisis & Aftercare", label: "Crisis & Aftercare" },
  { value: "Somatic Practices", label: "Somatic Practices" },
  { value: "Inner Child / Parts Work", label: "Inner Child / Parts Work" },
  {
    value: "Spiritual Emergence Support",
    label: "Spiritual Emergence Support",
  },
  { value: "Mindfulness and Meditation", label: "Mindfulness and Meditation" },
  { value: "Creative Expression", label: "Creative Expression" },
  { value: "Nature Connection", label: "Nature Connection" },
  { value: "Community Building", label: "Community Building" },
];

export const entheogenicOptions = [
  { label: "Psilocybin Mushrooms", value: "Psilocybin Mushrooms" },
  { label: "Ayahuasca", value: "Ayahuasca" },
  { label: "San Pedro (Huachuma)", value: "San Pedro (Huachuma)" },
  { label: "Peyote", value: "Peyote" },
  { label: "LSD", value: "LSD" },
  { label: "DMT", value: "DMT" },
  { label: "5-MeO-DMT", value: "5-MeO-DMT" },
  { label: "Iboga / Ibogaine", value: "Iboga / Ibogaine" },
  { label: "Salvia divinorum", value: "Salvia divinorum" },
  { label: "Amanita Muscaria", value: "Amanita Muscaria" },
  { label: "Yopo", value: "Yopo" },
  { label: "Syrian Rue", value: "Syrian Rue" },
  { label: "Blue Lotus", value: "Blue Lotus" },
  { label: "Mimosa Hostilis", value: "Mimosa Hostilis" },
  { label: "Acacia", value: "Acacia" },
  { label: "Betel Nut", value: "Betel Nut" },
  { label: "Coca Leaves", value: "Coca Leaves" },
  { label: "Kava", value: "Kava" },
  { label: "Cannabis (spiritual use)", value: "Cannabis (spiritual use)" },
  { label: "Breathwork", value: "Breathwork" },
];
